import Highcharts from "highcharts/esm/highcharts.src"

import { useMemo } from "react"

import { colors } from "@minuthq/meatball-ui-react"

export type PlottableEvent =
  | {
      value: number
      text: string
    }
  | {
      from: number
      to: number
      text: string
    }

export function useEventPlots({ events }: { events: PlottableEvent[] }) {
  const plotLineEvents = useMemo(() => {
    return events.filter((event) => "value" in event)
  }, [events])

  const plotBandEvents = useMemo(() => {
    return events.filter((event) => "from" in event)
  }, [events])

  const plotLines: Highcharts.XAxisPlotLinesOptions[] = useMemo(() => {
    return plotLineEvents.map(
      (event) =>
        ({
          color: colors.textPrimary,
          width: 2,
          value: event.value,
          dashStyle: "Dash",
          label: {
            text: event.text,
            rotation: 0,
            y: -5,
            textAlign: "center",
            style: {
              color: colors.textPrimary,
            },
          },
        }) satisfies Highcharts.XAxisPlotLinesOptions
    )
  }, [plotLineEvents])

  const plotBands: Highcharts.XAxisPlotBandsOptions[] = useMemo(() => {
    return plotBandEvents.map((event) => {
      return {
        from: event.from,
        to: event.to,
        label: {
          text: event.text,
        },
        color: colors.systemInfoLight,
      } satisfies Highcharts.XAxisPlotBandsOptions
    })
  }, [plotBandEvents])

  const marginTop = useMemo(() => {
    return plotLines.length > 0 ? 20 : undefined
  }, [plotLines])

  return { plotLines, plotBands, marginTop }
}
